var Operator = window.Operator || {};
Operator.blockEditors = Operator.blockEditors || {};

$.extend(Operator.blockEditors, {
    _generatePortsOnFormSubmit: function(event, editor, block, portType, portSelector){
        if(!Operator.blockEditors._generatePorts(editor, block, portType, portSelector)){
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
        }
    },
    
    _generatePorts: function(editor, block, portType, portSelector){
        var basePorts = Operator.Layout.connectionManager.getBlockConnectionSpec(block.data('blockId'));
        var blockElementId = block.attr('id');

        var basePortNames = _.map(basePorts[portType], 'name') || [];
        
        var portElements = editor.find(portSelector);
        var portNames = _.map(_.filter(portElements , function(e){
            return !!e.value 
        } ),'value');

        var selectedReservedPortNames = _.intersection(basePortNames, portNames);

        if (selectedReservedPortNames.length){
            alert('\'' + selectedReservedPortNames.join(', ') + '\' are reserved port named');
            return false;

        }

        var result = Operator.Layout.connectionManager.updateEndpointsFromSpecs(blockElementId, {
            input: _.concat(basePortNames, portNames)
        });

        if (!result.isValid){
            alert(result.errors.join('\n'));
        }
        
        return result.isValid;
    }
});